import * as Material from "@mui/material";

import "./styles.css";

import { ReactComponent as BuildProductDraw } from "@assets/draws/product-creation.svg";
import AddIcon from "@mui/icons-material/Add";

import SettingsIcon from "@mui/icons-material/Settings";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

import "react-image-crop/dist/ReactCrop.css";

import Screen from "@components/Screen";

import { Button } from '@fragments'

import { useCommunity } from "contexts/community";
import { ArrowForwardIosRounded, ShareRounded } from "@mui/icons-material";

export default function Communities() {
  document.title = "Comunidades | Ginastee";

  const { community } = useCommunity();

  window.communities = {};

  function handleOpenCreateNewCommunity() {
    community.management.open(null);
  }

  return (
    <>
      <Screen
        header={
          <>
            <div className="add-new-community-container">
              <h3>Suas Comunidades</h3>

              <Button
                color="white"
                onClick={handleOpenCreateNewCommunity}
                endIcon={<AddIcon />}
                text={"Criar nova comunidade"}
                className="create-new-community"
              />
            </div>
          </>
        }
      >
        <main className="communities-screen pb-8 ">
          <div className="communities-side">
            <CommunityList />
          </div>
        </main>
      </Screen>
    </>
  );
}

function CommunityList() {
  const { loading, communities, community } = useCommunity();

  const Community = ({ data = {} }) => {
    if (loading) return null

    return (
      <div className="community-row ">
        {data.banner ? (
          <img src={data.banner} className="community-banner" />
        ) : (
          <div className="community-banner"></div>
        )}

        <h3 className="px-1 title">{data.name}</h3>

        <div className="pl-1 pr-1  header-info">
          <>
            {data.isAdmin() && (
              <Material.IconButton
                onClick={() => community.management.open(data)}
              >
                <SettingsIcon color="white" />
              </Material.IconButton>
            )}

            <Material.IconButton
              onClick={() => community.triggerShareModal(data.id)}
            >
              <ShareRounded color="white" />
            </Material.IconButton>
          </>

        </div>

        <h5 style={{ opacity: 0.4 }}>Membros ativos {`: ${data.membersTotal || 0}`}</h5>

        <Material.Button
          className="open-community-btn"
          variant="contained"
          color="white"
          onClick={() => community.open(data.slug)}
        >
          Abrir comunidade
        </Material.Button>
      </div>
    );
  };
  const NoCommunities = ({ }) => {
    return (
      <div className="no-communities-box px-4 py-1">
        <BuildProductDraw className="no-communities-draw" />
        <div>
          <h3>Crie sua primeira comunidade</h3>
          <h5 className="pb-2">
            Adicione suas comunidades para engajar com sua audiência
          </h5>
          <Button
            variant="contained"
            color="primary"
            onClick={() => community.management.open(null)}
            endIcon={<AddIcon />}
            label={"Criar nova comunidade"}
          />
        </div>
      </div>
    );
  };

  const communitiesDisplay = loading
    ? [{}, {}, {}, {}]
    : communities;

  return (<>
    <h1 className="mt-5">Comunidades que você participa</h1>
    <div className="mt-3 communities-container">
      {communitiesDisplay.map((item, index) => (
        <Community data={item} key={index} />
      ))}
      {!loading && !communities?.length && <NoCommunities />}
    </div>
  </>
  );
}
